import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'app-invoices',
  imports: [RouterOutlet],
  templateUrl: './invoices.html',
  styleUrl: './invoices.scss',
})
export class Invoices {

}
